import { ButtonProps } from '@umu/umu-design';

/**
 * 能力模板类型
 */
enum TemplateType {
    MY = '1', // 1: 我的模板
    UMU = '3', // 3: umu 模版
    ENTERPRISE = '4', // 4: 企业模版
}
/**
 * 组件展示模式
 */
enum VIEW_MODE {
    EDIT = 1,
    VIEW,
}
/**
 * 操作类型
 */
enum OPERATE_TYPE {
    VIEW, // 查看
    EDIT, // 编辑
    DELETE, // 删除
}
/**
 * 模板页面类型
 */
enum PanelType {
    LIST = 1, // 模板列表
    ADD, // 模板新增
    EDIT, // 模板编辑
    PREVIEW, // 模板预览
    SELECT_CAPABILITY_DETAIL, // 选择能力页面
}
/**
 * 模板问题类型
 */
enum QuestionType {
    PARAGRAPH = 1, // 段落
    RADIO, // 单选
    CHECKBOX3, // 多选
    TEXT, // 文本
    NUMBER5, // 数字
}

/**
 * 数据通讯类型
 */
enum ActType {
    UPDATE_PANEL_TYPE, // 更换页面展示
    PANEL_CANCEL, // 关闭页面
    PANEL_SUBMIT, // 提交页面
    UPDATE_TEMPLATE_LIST, // 更新模板列表
    UPDATE_TEMPLATE_SELECT, // 更新模板选中数据
    UPDATE_TEMPLATE_TYPE, // 更新模板类型
}
/**
 * 模版类型列表基础配置信息
 */
interface ITemplateTypeInfo {
    emptyText: string;
    title: string;
}
enum QuestionOperateType {
    CHANGE_CONFIG = 1,
    CANCEL_OPERATE, // 取消操作
    COPY_TO, // 复制到此
    MOVE_TO, // 移动到此
    /*******题干*******/
    ADD,
    COPY,
    DELETE,
    MOVE,
    CHANGE_TITLE,
    CHANGE_TYPE,
    UPDATE_IMG,
    /*******选项*********/
    CHANGE_OPTION_LIST,
    OPTION_ADD,
    OPTION_DELETE,
}
type ITemplateTypeMapInfo = Record<TemplateType, ITemplateTypeInfo>;
interface IQuestionInfoSetUp {
    extra_required: number;
    limit_options_max: string;
    limit_options_min: string;
    number_default: number;
    number_max: string;
    number_max_tag: string;
    number_min: string;
    number_min_tag: string;
    require: number;
    weights: number;
}

interface ITemplateQuestionInfo {
    id: string;
    index: number;
    desc?: string;
    extend?: {
        resource_arr: IResourceInfo[];
        setup: IQuestionInfoSetUp;
    };
    weights?: number;
    type: QuestionType;
    title: string;
    list?: ITemplateQuestionInfo[];
}

/**
 * 多维度能力模板信息
 */
interface IMultiCapabilityTemplateInfo {
    id: string;
    create_ts: number;
    desc: string;
    paragraph_num: number;
    question_num: number;
    student_id: string;
    title: string;
    parent_type: TemplateType;
    evaluation_criteria_id: string;
    update_ts: number;
    weights: number;
    list?: ITemplateQuestionInfo[]; // 问题列表
}
/***
 * 模板配置页面信息
 */
interface ISelectTemplateInfo {
    templateType: TemplateType;
    info: IMultiCapabilityTemplateInfo;
}
type TemplateQuestionInfoMap = Record<string, any>;
interface ITemplateQuestionConfig {
    mapInfo: React.MutableRefObject<TemplateQuestionInfoMap>;
}
interface IEditorConfig {
    isShowPreview?: boolean; // 是否展示预览按钮
    isShowPreStep?: boolean; // 是否展示上一步
    isShowCancel?: boolean; // 是否展示取消按钮
    title?: string | JSX.Element;
    mode?: VIEW_MODE;
}
interface IMultiCapabilityTemplatePageInfo {
    templateType: TemplateType;
    title: string;
    panelType: PanelType;
    isShowBack: boolean;
    previewPanelType?: PanelType[];
    isLoading: boolean;
    templateInfo?: IMultiCapabilityTemplateInfo;
    editorConfig: IEditorConfig;
    dataSource: {
        listData: Record<TemplateType, ITemplateListInfo>;
        listSelectInfo?: ISelectTemplateInfo;
    };
}
/**
 * 模板页面基础配置信息
 */
interface ITemplateComponentProps extends IMultiCapabilityTemplatePageInfo {
    onCommunication: (type: ActType, data: any) => Promise<boolean>;
}
type ITemplateComponent = (props: ITemplateComponentProps) => JSX.Element;
interface ITemplatePanelInfo {
    title: string;
    pageComponent: {
        HeardContent?: ITemplateComponent;
        BodyContent: ITemplateComponent;
        FooterContent?: ITemplateComponent;
    };
}
type ITemplatePanelTypeMapInfo = Record<PanelType, ITemplatePanelInfo>;
/*****列表数据信息****/
interface ITemplateParams {
    parent_type: TemplateType | '2'; // 2 代表 element 下的问题
    id?: string;
    page?: number;
    size?: number;
    get_base?: number;
    evaluation_criteria_id?: string;
}

interface ITemplateListInfo {
    page_info: IPageInfo;
    list: IMultiCapabilityTemplateInfo[];
}
interface ISubmitData {
    parent_type: TemplateType;
    templateInfo: IMultiCapabilityTemplateInfo;
}
interface IQuestionProps {
    mode: VIEW_MODE;
    weights?: string;
    isValid?: boolean;
    info: ITemplateQuestionInfo;
    templateType?: TemplateType;
    onCommunication: (type: QuestionOperateType, data: any) => Promise<boolean>;
}

interface IOperateItem extends ButtonProps {
    key: QuestionOperateType;
    iconType?: string;
    label: string;
    isUploadFile?: boolean;
    accept?: string;
}
interface IOperateConfig {
    isShow: boolean;
    index: number;
    type: QuestionOperateType;
}
export {
    QuestionOperateType,
    IOperateItem,
    ActType,
    IOperateConfig,
    VIEW_MODE,
    TemplateType,
    OPERATE_TYPE,
    PanelType,
    ISubmitData,
    IQuestionProps,
    ISelectTemplateInfo,
    IQuestionInfoSetUp,
    IMultiCapabilityTemplateInfo,
    TemplateQuestionInfoMap,
    ITemplateParams,
    QuestionType,
    ITemplateQuestionInfo,
    ITemplateQuestionConfig,
    ITemplateListInfo,
    IMultiCapabilityTemplatePageInfo,
    ITemplateTypeMapInfo,
    ITemplateComponentProps,
    ITemplatePanelTypeMapInfo,
};
